const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

(() => {
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const blockedExact = new Set([
    'free shipping for all orders over $10.00',
    'free delivery worldwide',
    'summer sale! 50% off for boots!'
  ]);
  const countdownLabels = ['days', 'hour', 'mins', 'secs'];

  function removeBlockedClaims(root = document) {
    root.querySelectorAll('body *').forEach((element) => {
      const text = normalize(element.textContent);
      if (!blockedExact.has(text)) return;
      const removable = element.closest('p, small, li, section, aside, div, span') || element;
      removable.remove();
    });
  }

  function removeCountdown(root = document) {
    const matches = [...root.querySelectorAll('body *')].filter((element) =>
      countdownLabels.includes(normalize(element.textContent))
    );
    if (matches.length < 4) return;

    for (const match of matches) {
      let container = match;
      while (container && container !== document.body) {
        const text = normalize(container.innerText);
        if (countdownLabels.every((label) => text.includes(label))) {
          container.remove();
          return;
        }
        container = container.parentElement;
      }
    }
  }

  function cleanLegacyPromotions() {
    if (!document.body) return;
    removeBlockedClaims();
    removeCountdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanLegacyPromotions, { once: true });
  } else {
    cleanLegacyPromotions();
  }

  const observer = new MutationObserver(cleanLegacyPromotions);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 30000);
})();
